<template>
<div>
    <h2>{{ $t("eventStatisticsView.topParticipants", [store.selectedEvent.name, numTop]) }}</h2>
    <kk-event-participant-top-list :event="store.selectedEvent" :num-top="numTop"/>
</div>
</template>

<script lang="ts">
import { store } from "store";
import "@/components/EventParticipantTopList.vue";
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            store: store
        };
    },
    props: {
        numTop: {
            type: Number
        }
    }
})
</script>